import "./scss/custom.scss";
import "./js/main";
//import 'bootstrap';
import bootstrap from 'bootstrap/dist/js/bootstrap.js'
window.bootstrap = bootstrap
